"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function ResponsiveImage({
  fullSizeUrl,
  sources = [{
    srcsets: [''],
    media: ''
  }],
  altText = '',
  classname = '',
  handleClick = () => true,
  loading = 'lazy',
  // null/'eager', 'lazy'
  decoding = 'async',
  // 'sync', 'async', 'auto'
  fetchpriority = null // null/'low', 'high'
}) {
  return /*#__PURE__*/_react.default.createElement("picture", {
    className: classname
  }, sources.map((source, index) => /*#__PURE__*/_react.default.createElement("source", {
    media: `(${source.media})`,
    srcSet: source.srcsets.join(', '),
    key: `source-${index}`
  })), /*#__PURE__*/_react.default.createElement("img", {
    src: fullSizeUrl,
    alt: altText,
    onClick: handleClick,
    loading: loading,
    decoding: decoding,
    fetchpriority: fetchpriority
  }));
}
var _default = exports.default = ResponsiveImage;